import { Component, EventEmitter, inject, OnDestroy, OnInit, Output } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { AuthenticationStore } from '../../states/auth/auth.store';
import { UserProfileStore } from '../../states/user-profile/user-profile.store';

@Component({
  selector: 'app-admin-header',
  standalone: false,
  templateUrl: './admin-header.html',
  styleUrl: './admin-header.css',
})
export class AdminHeader implements OnInit, OnDestroy {
  @Output() menuToggle = new EventEmitter<void>();

  private readonly authStore = inject(AuthenticationStore);
  readonly userProfileStore = inject(UserProfileStore);
  private readonly router = inject(Router);

  currentTime = '';
  private timerId?: ReturnType<typeof setInterval>;

  ngOnInit(): void {
    this.tick();
    this.timerId = setInterval(() => this.tick(), 30_000);
  }

  ngOnDestroy(): void {
    if (this.timerId) clearInterval(this.timerId);
  }

  onLogout(): void {
    this.authStore.logout();
    this.router.navigate(['/login']);
  }

  private tick(): void {
    this.currentTime = new Date().toLocaleTimeString('en-PH', {
      hour: '2-digit',
      minute: '2-digit',
    });
  }
}
